var _effectorFileName = "/builds/gmini/front-ui-kit/src/MacosExplorer/MacosExplorer.tsx";
import React from 'react';
import { ExplorerBody } from './ExplorerBody';
import { ExplorerPropsCtx } from './propsCtx';
import { fromRefs, findParents, toRefs, withRoot, withRootLoading } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function MacosExplorer(props) {
  const {
    activeItems: activeItemRefs,
    treeData,
    rootLoading = false,
    rootSkeletonItemsCount = 5,
    fetchChildren,
    onChangeActive,
    onPanelContextMenu,
    onMove,
    panelWidth,
    canDrop,
    emptyPanelTitle,
    // TODO: maybe create unique string (uuid or rand)
    dndType = 'MacosExplorer_dndType'
  } = props;
  const withRootTreeData = React.useMemo(() => withRoot(treeData, {
    skeletonTotal: rootSkeletonItemsCount
  }), [rootSkeletonItemsCount, treeData]);
  const activeItems = React.useMemo(() => withRootTreeData[0] ? [withRootTreeData[0], ...fromRefs(withRootTreeData, activeItemRefs)] : fromRefs(withRootTreeData, activeItemRefs), [withRootTreeData, activeItemRefs]);
  const [loadingMap, setLoadingMap] = React.useState({}); // Добавляем loading для рутовой панели

  const withRootLoadingMap = React.useMemo(() => withRootLoading(loadingMap, rootLoading), [loadingMap, rootLoading]);

  const setItemLoading = (key, val) => {
    setLoadingMap(prev => {
      if (prev[key] && !val) {
        const next = { ...prev
        };
        delete next[key];
        return next;
      } else if (!prev[key] && val) {
        return { ...prev,
          [key]: true
        };
      }

      return prev;
    });
  };

  const handleOnSelect = React.useCallback(async (item, noFetch) => {
    // найти всех родителей
    const parents = findParents(treeData, item); // закинуть всю цепочку в active

    onChangeActive(toRefs([...parents, item]));

    if (noFetch) {
      return;
    }

    setItemLoading(item.key, true);

    try {
      await fetchChildren(item);
    } catch (error) {
      console.error(error);
    } finally {
      setItemLoading(item.key, false);
    }
  }, [fetchChildren, onChangeActive, treeData]);
  return /*#__PURE__*/_jsx(ExplorerPropsCtx.Provider, {
    value: props,
    children: /*#__PURE__*/_jsx("div", {
      style: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      },
      children: /*#__PURE__*/_jsx(ExplorerBody, {
        activeItems: activeItems,
        onSelectItem: handleOnSelect,
        loadingMap: withRootLoadingMap,
        onPanelContextMenu: onPanelContextMenu,
        onMove: onMove,
        panelWidth: panelWidth,
        canDrop: canDrop,
        emptyPanelTitle: emptyPanelTitle,
        dndType: dndType
      })
    })
  });
}
MacosExplorer.displayName = 'MacosExplorer';